import { Dispatch } from 'redux';
import kebabCase from 'lodash/kebabCase';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import {
  DispatcherCategoryService,
  DispatcherAuthPrefix,
  DispatcherResource,
  DispatcherEndpoint
} from 'modules/types/common';
import FileServices from 'services/FileServices';
import { sendAuditLog } from 'store/audit/actions';
import dayjs from 'dayjs';
import { profileConsumerSelector } from 'store/profile/selectors';
import { RootState } from 'store/types';
import { Consumer } from 'store/profile/types';
import DeviceInfoServices from 'services/DeviceInfoServices';
import { v4 } from 'uuid';
import {
  AuditAccessRecord,
  AuditAccessTypes,
  AuditActionIds,
  AuditCategory,
  AuditData
} from '../audit/types';

/**
 * Download Clinic Note Document
 */
export const CLINIC_NOTES_DOWNLOAD_DOCUMENT = 'CLINIC_NOTES.DOWNLOAD_DOCUMENT';
export const CLINIC_NOTES_DOWNLOAD_DOCUMENT_SUCCESS = 'CLINIC_NOTES.DOWNLOAD_DOCUMENT_SUCCESS';
export const CLINIC_NOTES_DOWNLOAD_DOCUMENT_FAIL = 'CLINIC_NOTES.DOWNLOAD_DOCUMENT_FAIL';

const parseClinicNotesDownloadAuditData = (consumer: Consumer, description: string): AuditData => {
  const auditComment = {
    categoryId: AuditCategory.CLINICAL_NOTES_AND_DOCUMENTATION,
    actionBy: `${consumer.lastName}, ${consumer.firstName}`,
    description,
    transmittedTo: '',
    requestId: v4()
  };

  return {
    comment: JSON.stringify(auditComment),
    targetURL: getDispatcherUrl(
      DispatcherCategoryService.HEALTH_RECORDS,
      DispatcherAuthPrefix.AUTHENTICATED,
      DispatcherResource.CLINIC_DOCUMENTS,
      DispatcherEndpoint.ID
    ),
    actionId: AuditActionIds.DOWNLOAD,
    mmiNumber: consumer.consumerId,
    accessType: AuditAccessTypes.MILLENNIUM,
    mobileDeviceId: DeviceInfoServices.getDeviceId(),
    accessRecord: AuditAccessRecord.HEALTH_RECORD_SERVICE
  };
};

export const downloadClinicNotesDocument = (
  title: string,
  data: string,
  createDate: string
) => async (dispatch: Dispatch, getState: () => RootState) => {
  dispatch({ type: CLINIC_NOTES_DOWNLOAD_DOCUMENT });

  const state = getState();

  const consumer = profileConsumerSelector(state) as Consumer;
  const description = `Downloaded ${title} (${dayjs(createDate).format('YYYY/MM/DD')})`;
  try {
    await FileServices.saveDataToFile(`${kebabCase(title)}-${Date.now().toString()}.pdf`, data);
    const auditData = parseClinicNotesDownloadAuditData(consumer, description);
    dispatch(sendAuditLog(auditData));

    dispatch({ type: CLINIC_NOTES_DOWNLOAD_DOCUMENT_SUCCESS, payload: {} });
  } catch (err) {
    dispatch({ type: CLINIC_NOTES_DOWNLOAD_DOCUMENT_FAIL, payload: {}, error: err });
  }
};
